import React from 'react';
import API from "@beardeddevops/react.api";

import Framework from "@beardeddevops/react.framework"
import {Parts} from "components";
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import UserRoles from "../../../../../constants/UserRoles";
import ScheduleComponent from "../../../../../components/Parts/ScheduleComponent";
import Types from "../../../../../constants/Types";
import {Button} from "reactstrap";
import APPCONFIG from "../../../../../constants/Config";
import moment from "moment";


const breadcrumbStatic = [{
	name: 'Contractor Schedules',
	url: '/managers/approvals',
	icon: 'dashboard'
}];

export default class ScheduleApproval extends Framework.Components.View {

	constructor(props) {
		super(props);
		this.state.data = null;
	}

	async componentDidMount() {
		let schedule_model = new API.BuildClass(Types.Schedule_Approvals._name, API.RequestType.GET);
		schedule_model.object.pkey = this.props.match.params.id;
		const data = await schedule_model.submit(null, 'GET')
		this.setState({data})
	}
	render() {
		let {match, history, baseUrl, roles} = this.props;
		let {data} = this.state;

		return (
			<div className="container-fluid">
				<Framework.Components.PageBar breadcrumbs={breadcrumbStatic} history={history}/>
				{data && <Parts.ScheduleComponent disabled={true} isEngineer={data.isEngineer} defaultDate={data.week_of} blocks={data.data_obj.defaultBlocks} initialData={data.data_obj.selectedData}/>}

				<div className={'col-6 offset-3'} key={this.state.data} style={{
					textAlign: "center",
					border: "1px solid #e8e8e8",
					borderRadius: "5px",
					boxShadow: "0 1px 4px rgba(0, 0, 0, 0.27), 0 0 40px rgba(0, 0, 0, 0.08) inset"
				}}>
					{this.state.data?.signature ?
					<img
					     src={APPCONFIG.settings.apiURL() + '/' + APPCONFIG.settings.apiVersion + '/schedule_approvals/signature?image=' + this.state.data?.signature}
					     alt={"Something went wrong rendering the signature, please reach out to Mason"}
					/> :
						<span>
							Something went wrong rendering the signature, please reach out to Mason
						</span>
					}
				</div>
				<div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
					{data && <i style={{textAlign: 'center', width: '100%'}}>Signed on {moment(data.created).format('MM/DD/YY')}&nbsp;at {moment(data.created).format('h:mm a')} by {data.user}</i>}
					<Button color="secondary" onClick={() => (history.goBack())}>Back</Button>
				</div>
			</div>
		)
	}
};
